import { httpClient } from '../httpClient/httpClient';
import { RequestOptionsWithBody } from '../httpClient/types';
import { PagedItems } from '@texas/types';

export interface ArchivedEntity {
  id: number | string;
  name: string;
  identifier: string | null;
  parent: string | null;
  archived: string;
}

export interface ArchiveSearchQuery {
  searchTerm: string;
  sortBy: string;
  sortDesc: boolean;
  page: number;
  pageSize: number;
}

export const archiveApi = {
  getArchived: (
    organizationId: number,
    archivePath: string,
    query: ArchiveSearchQuery,
  ) =>
    httpClient.get<PagedItems<ArchivedEntity>>(
      `organizations/${organizationId}/archive/${archivePath}`,
      { params: query },
    ),
  restore: (path: string, options?: RequestOptionsWithBody) =>
    httpClient.put(path, options),
};
